import { styled } from "@mui/material/styles";
import { DIRECT_PATHS } from "constants/routes";
import { useIntl } from "react-intl";
import { COLORS } from "constants/layout";
import { StyledRouterA } from "../Text";

type ViewProductData = {
  farm_item?: string;
};

interface ViewProductButtonProps {
  data?: ViewProductData;
  textId?: string;
  className?: string;
}

const ViewProductButton = (props: ViewProductButtonProps) => {
  const { data, textId = "view_product", className } = props;
  const t = useIntl();
  const { farm_item } = data || {};

  if (!farm_item) return null;

  return (
    <StyledLink
      to={DIRECT_PATHS.itemDetail(farm_item)}
      className={`view-product-btn ${className || ''}`}
      sx={{
        fontSize: {
          xs: 12,
          md: 14,
        },
      }}
    >
      {t.formatMessage({ id: textId })}
    </StyledLink>
  );
};

const StyledLink = styled(StyledRouterA)({
  color: `${COLORS.green[600]} !important`,
  textDecoration: "none",
  fontSize: "inherit",
  fontFamily: "inherit",
  padding: 0,
  "&:hover": {
    textDecoration: "underline",
  },
});

export default ViewProductButton; 